import {fetchTransaction} from '@components/Transaction/transactionSlice';
import fetchDesignerBase from './fetchDesignerBase';

export default function fetchTransactionDesigner({
    store, headers, baseUrl, params, options
}) {
    return [
        ...fetchDesignerBase({
            store, headers, baseUrl, params, options
        }),
        store.dispatch(fetchTransaction({
            headers, baseUrl, params, options
        }))
    ];
}
